/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Upload_HelpInputs */

const en_image_upload_help = /** @type {(inputs: Image_Upload_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max 10MB. JPG, PNG, WebP.`)
};

const es_image_upload_help = /** @type {(inputs: Image_Upload_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max 10MB. JPG, PNG, WebP.`)
};

/**
* | output |
* | --- |
* | "Max 10MB. JPG, PNG, WebP." |
*
* @param {Image_Upload_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const image_upload_help = /** @type {((inputs?: Image_Upload_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Upload_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_image_upload_help(inputs)
	return es_image_upload_help(inputs)
});